import React from 'react'
import { ActivityProgress, GoalWithProgress } from '../../../../services/api.types'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { t } from 'ttag'
import { formatThousands } from '../../../../common/helpers/translations'
import { primaryBlue, darkBlue } from '../../../../styles/material-ui-theme-v2'
import { getChallengePersonalProgressCurrently, isDistanceType } from '../../../../common/helpers/challenges'
import { getCustomCategory } from '../../../../services/CustomTypes'
import { YumActivityIcon } from '../../../YumActivityIcon/YumActivityIcon'

import { ReactComponent as AverageIcon } from '../../../../assets/v3/icons/collective/average.svg'

export interface IYumChallengeActivityIndexProgressProps {
  goal: GoalWithProgress
  activityProgress: ActivityProgress
}

const useStyles = makeStyles((theme) => ({
  wrapper: {
    backgroundColor: 'white',
    padding: '10px',
    borderRadius: '8px',
    marginBottom: '16px',
  },
  total: {
    fontWeight: 500,
    fontSize: '28px',
    lineHeight: '33px',
  },
  unit: {
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '21px',
    opacity: 0.5,
    marginLeft: '4px',
  },
  separator: { height: '1px', background: darkBlue, opacity: 0.25, margin: '8px 0' },
  componentInner: { display: 'flex', flexDirection: 'row', justifyContent: 'space-between' /*, gap: '8px'*/ },
  componentText: {
    flexGrow: 1,
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: '32px',
    marginLeft: '8px',
    marginRight: '8px',
  },
  componentNumber: { flexGrow: 1, fontSize: '28px', fontWeight: 500, lineHeight: '32px', textAlign: 'right' },
  blue: { color: primaryBlue },
}))

export default function YumChallengeCollectiveProgress(props: IYumChallengeActivityIndexProgressProps) {
  const classes = useStyles()
  const { goal, activityProgress } = props
  const { customType, collectiveTotal, participantsCount, progressType } = goal

  const isDistance = isDistanceType(customType)
  const decimals = isDistance ? 2 : 0

  const yourContribution = formatThousands(getChallengePersonalProgressCurrently(goal, activityProgress), decimals)
  const averageContribution = formatThousands(participantsCount ? collectiveTotal / participantsCount : 0, decimals)

  const SubComponent = ({
    icon,
    text,
    number,
    className,
  }: {
    icon: any
    text: string
    number: string
    className?: string
  }) => (
    <div className={className}>
      <div className={classes.componentInner}>
        <div>{icon}</div>
        <div className={classes.componentText}>{text}</div>
        <div className={classes.componentNumber}>{number}</div>
      </div>
    </div>
  )

  const Separator = () => <div className={classes.separator}></div>

  return (
    <>
      <div className={classes.wrapper}>
        {activityProgress && (
          <>
            <SubComponent
              className={classes.blue}
              /*icon={getIcon(progressType, customType)}*/
              icon={
                <YumActivityIcon
                  category={getCustomCategory(progressType, customType)}
                  color={'darkBlue'}
                  bg={'lightBlue'}
                />
              }
              text={t`Your contribution`}
              number={yourContribution}
            />
            <Separator />
          </>
        )}
        <SubComponent icon={<AverageIcon />} text={t`Average contribution`} number={averageContribution} />
      </div>
    </>
  )
}
